import { render, staticRenderFns } from "./Moment.vue?vue&type=template&id=16f5900e&"
import script from "./Moment.vue?vue&type=script&lang=js&"
export * from "./Moment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/krankerl.FFR503Cp8cB3/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16f5900e')) {
      api.createRecord('16f5900e', component.options)
    } else {
      api.reload('16f5900e', component.options)
    }
    module.hot.accept("./Moment.vue?vue&type=template&id=16f5900e&", function () {
      api.rerender('16f5900e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavigation/CalendarList/Moment.vue"
export default component.exports